// extracted by mini-css-extract-plugin
export default {"progressContainer":"StepProgress_progressContainer__0GgiG","progress":"StepProgress_progress__5dZJb"};